module.exports = __webpack_public_path__ + "static/media/Martino Brambilla.31cbfb83.png";